// Fuerza el precio/badge visual de productos con precio base "Releasit" (precio real distinto
// al mostrado) en cualquier tarjeta de producto del sitio: catálogo/colecciones, portada,
// búsqueda y el carrusel "también te puede interesar". El precio real en Shopify sigue siendo
// el que usa Releasit para armar sus packs; esto solo cambia lo que se ve en pantalla.
(function () {
  var PRICE_OVERRIDES = {
    'serum-facial-con-acido-hialuronico': { price: '$25.990', badge: 'AHORRA 16%' },
    'crema-anti-estrias-reparadora-hidratante': { price: '$23.990', badge: 'AHORRA 23%' },
    'bloqueador-facial-de-romero-anti-acne': { price: '$26.990', badge: 'AHORRA 18%' },
    'crema-de-noche-antiedad-con-retinol': { price: '$27.990', badge: 'AHORRA 15%' },
    'crema-anti-hongos': { price: '$25.990', badge: 'AHORRA 16%' },
    'jabon-limpiador-facial-anti-acne': { price: '$24.990', badge: 'AHORRA 19%' },
    'terbifin-spray-8-anti-hongos-pies-unas': { price: '$23.990', badge: 'AHORRA 20%' },
    'nad-resveratrol-americano-60-capsulas': { price: '$24.990', badge: 'AHORRA 24%', before: '$32.990' }
  };

  function applyOverrides() {
    Object.keys(PRICE_OVERRIDES).forEach(function (handle) {
      var cfg = PRICE_OVERRIDES[handle];
      var links = document.querySelectorAll('a[href*="/products/' + handle + '"]');
      links.forEach(function (a) {
        var card = a.closest('.card-wrapper');
        if (card && !card.dataset.priceOverridden) {
          var priceEl = card.querySelector('.price');
          if (priceEl) priceEl.classList.add('price--on-sale');
          var saleEl = card.querySelector('.price-item--sale');
          if (saleEl) saleEl.textContent = cfg.price;
          // Si el producto no tiene compareAtPrice real en Shopify, el <s> del precio
          // tachado queda vacío nativamente — lo completamos con el valor decorativo.
          var compareEl = card.querySelector('.price__compare-price .price-item--regular');
          if (compareEl && compareEl.textContent.trim() === '' && cfg.before) {
            compareEl.textContent = cfg.before;
          }
          var badgeContainer = card.querySelector('.card__badge');
          var badgeEl = card.querySelector('.card__badge .nowrap');
          if (badgeEl) {
            badgeEl.textContent = cfg.badge;
          } else if (badgeContainer) {
            var span = document.createElement('span');
            span.className = 'badge badge--bottom-left color-accent-2';
            var nowrap = document.createElement('span');
            nowrap.className = 'nowrap';
            nowrap.textContent = cfg.badge;
            span.appendChild(nowrap);
            badgeContainer.appendChild(span);
          }
          card.dataset.priceOverridden = '1';
        }
        var hprod = a.closest('.hprod-card');
        if (hprod && !hprod.dataset.priceOverridden) {
          var nowEl = hprod.querySelector('.hprod-price-now');
          if (nowEl) nowEl.textContent = cfg.price;
          hprod.dataset.priceOverridden = '1';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', applyOverrides);

  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyOverrides, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
